import { AppConfiguration } from "config";
import { genericGetRequest } from "helpers/sf_backend_helper";

import { takeEvery, call, put } from "redux-saga/effects";
import { GET_AD_GROUP_LOCATIONS } from "./actionTypes";
import { getAdGroupLocationsError, getAdGroupLocationsSuccess } from "./actions";
import { getAuthHeaders } from "helpers/sf_utils";

function* onGetAdGroupLocations(action) {
	try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/ad_group_locations`,
			{
				ad_group_id: action.payload.ad_group_id
			},
      getAuthHeaders()
    )
    yield put(getAdGroupLocationsSuccess(response))
  } catch (error) {
    yield put(getAdGroupLocationsError(error))
  }
}


function* adGroupLocationsSaga() {
	yield takeEvery(GET_AD_GROUP_LOCATIONS, onGetAdGroupLocations)
}

export default adGroupLocationsSaga;
